<div class="docEditor">
  <div class="editor-container mt-2">
    @if (editMode) {
    <div class="w-100 header-container d-flex align-items-center justify-content-between docEditor__header">
      <div class="buttons__container d-flex align-items-center justify-content-end">

        <i-button text="Enregistrer" [pTooltip]="'save' | translate" tooltipPosition="bottom"
          (click)="sendToComponent()" styleClass="blue me-2"></i-button>
      </div>
    </div>
    }
    <div class="myEditor" cdkDropList #doneList="cdkDropList" [cdkDropListConnectedTo]="LIST_IDS"
      (cdkDropListDropped)="dropped($event)">
      <i-richedit [lang]="lang" [showMergeFields]="true" [mergeFields]="mergeFields()" #document_editor></i-richedit>
    </div>
  </div>
</div>

<p-sidebar position="right" [(visible)]="showFusion" styleClass="ui-sidebar-sm" [modal]="false">
  <div class="ms-1 me-1">
    <i-title text="Champs de fusion"></i-title>
    <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValue" />
  </div>
  <i-accordion [hideShowAllBtn]="true">
    @for (item of fusions | keyvalue; track item; let i = $index) {
    <i-accordion-tab [showEditBtn]="false" header="{{ item.key }}" class="box" cdkDropList [attr.id]="'todoList' + i"
      [cdkDropListData]="item.value" [cdkDropListConnectedTo]="[doneList]">
      <div class="mergeFields">
        @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'key' : searchValue; track text) {
        <div class="cell" (click)="copy($event, text)" (dblclick)="insert(text.key)" [cdkDragData]="text.key" cdkDrag>
          <div [pTooltip]="text.description ? text.description : text.key">
            <i class="bi bi-copy me-1"></i>{{ text.description ? text.description : text.key }}
          </div>
        </div>
        }
      </div>
    </i-accordion-tab>
    }
  </i-accordion>
</p-sidebar>